import { render, staticRenderFns } from "./LinePointDeposit.vue?vue&type=template&id=6675d40a&scoped=true&"
import script from "./LinePointDeposit.vue?vue&type=script&lang=js&"
export * from "./LinePointDeposit.vue?vue&type=script&lang=js&"
import style0 from "./LinePointDeposit.vue?vue&type=style&index=0&id=6675d40a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6675d40a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VFileInput,VRow,VTextField})
